/**
 * Pure month/day helpers for the Change Log calendar, extracted from
 * `ChangelogPanel.tsx` so the month-string + month-shift + day-format logic
 * unit-tests directly.
 */

export function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

/** A `YYYY-MM` month key for a Date (local time). */
export function monthStr(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
}

/** Shift a `YYYY-MM` month key by `delta` months (handles year wrap). */
export function shiftMonth(month: string, delta: number): string {
  const [y, m] = month.split("-").map(Number) as [number, number];
  return monthStr(new Date(y, m - 1 + delta, 1));
}

/** A `YYYY-MM-DD` date as a long, locale-formatted day (e.g. "22 June 2026"). */
export function formatDay(date: string): string {
  const [y, m, d] = date.split("-").map(Number) as [number, number, number];
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
